// extracted by mini-css-extract-plugin
export var fullWidthButton = "_qc-0";